import i18n from '@fe/i18n';
import { useCallback, useEffect, useState } from 'react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import { Address, UserInfo } from 'states/interface';

interface InitUserInfo extends Required<UserInfo> {
    addressInfo: Address;
    studentName: string;
}

const initUserInfo: InitUserInfo = {
    userId: NaN,
    avatar: '',
    studentName: '',
    birthday: '',
    areaCode: '',
    mobile: '',
    email: '',
    addressInfo: { address: '', id: NaN },
    userName: '',
    age: NaN,
    gender: '',
    isPaid: false,
    stuId: NaN
}
/**
 * @description 用户信息初始化
 * @date 2022-03-01
 * @export
 * @returns {*}  
 */
export function useUser() {
    const userInfo = useSelector((state: ConnectState) => state.app.user) || initUserInfo
    Object.keys(userInfo).forEach(key => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        //@ts-ignore
        if (userInfo[key]) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            //@ts-ignore
            initUserInfo[key] = userInfo[key]
        }
    })
    return initUserInfo

}